<label class="field__label">{{label}}</label>
<div class="options-container">
    <div *ngFor="let option of options">
        <label class="option">
            <input
                value="{{option.value}}"
                class="option__input"
                type="checkbox"
                (click)="setValue($event)"
                [checked]="optionIsSelected(option)"
            />
            {{option.htmlLabel}}
        </label>
    </div>
    <ErrorMessages [errorMessages]="errorMessages"></ErrorMessages>
</div>
